import React from 'react';

import Resources from "../Resources";

function createColumnDefs() {
  const columnDefs = [
    { name: 'ResourceId', label: 'Account Id', options: { display: true, filter: false } },
    { name: 'ClientAccountId', options: { display: false, filter: false } },
    { name: 'ClientAccountAlias', label: 'Name', options: { filter: false } },
    { name: 'Description', options: { display: true, filter: false } },
    { name: 'OwnedResources', label: 'Owned Resources', options: { display: true, filter: false } },
    { name: 'ResourceType', options: { display: false, filter: false } },
    { name: 'StackUpdated', options: { display: true } },
    { name: 'ClientConfiguration.ResourceMetadata.SharingStatus', label: 'Metadata', options: { display: false } },
  ];
  return columnDefs;
}

export default function Clients(props) {

  const columnDefs = createColumnDefs();

  return (
    <Resources 
      type='Client' 
      columnDefs={columnDefs} 
    />
  );
}

Clients.propTypes = {
};

Clients.defaultProps = {
};
